module.exports = "/packs/images/homepage/facilities/junior-gym~241e4c8af941674215933c081cfde2ab.jpg";